<template>
    <v-card flat >
        <v-card-title>
            <div class="title" v-if="model">{{model.name}}</div>
        </v-card-title>

        <v-card-text>
            <v-form v-if="model" v-model="valid">
                <template v-for="(field, i) in model.physical_exam_fields">
                    <v-text-field
                            :rules="rules"
                            @keydown.enter.prevent="()=>{}"
                            clearable
                            :key="i"
                            :value="field.value || '' "
                            v-model="model.physical_exam_fields[i].value"
                            :label="field.label" />
                </template>
            </v-form>
        </v-card-text>

        <v-card-actions v-if="!isReadOnly">
            <v-spacer></v-spacer>
            <v-btn :loading="loadingAttach" depressed color="primary" :disabled="!valid" @click.prevent="attach">
                Guardar
                <v-icon class="ml-2" size="14">fa-save</v-icon>
            </v-btn>
        </v-card-actions>

    </v-card>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapState, mapMutations} from 'vuex'

    export default{
        props: ['exam', 'readonly', 'eventId'],
        data(vm){
            return {
                loadingAttach: false,
                valid: false,
                rules: [
                        v => !!v || 'Campo obligatorio'
                ],
                model: null
            }
        },
        mounted(){
            this.setDefaults()
        },
        computed: {
            isReadOnly(){
                return this.readonly !== undefined && this.readonly !== false
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            setDefaults(){
                var vm = this
                if(vm.exam){
                    const model = JSON.parse(JSON.stringify(vm.exam))

                    for(var i in model.physical_exam_fields){
                        model.physical_exam_fields[i].value = model.physical_exam_fields[i].value || ''
                    }

                    vm.model = model
                }
            },
            async attach(){
                var vm = this

                if(vm.loadingAttach) return


                vm.loadingAttach = true
                const response = await ApiUtils.makePost(`exams/physical/attach`, {
                    physical_exam_id: vm.model.id,
                    schedule_event_id: vm.eventId,
                    values: vm.model.physical_exam_fields.map(exam => {
                        return {
                            field_name: exam.field_name,
                            value: exam.value
                        }
                    })
                })
                vm.loadingAttach = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando agregar el examen')
                    return
                }

                const json = await response.json()
                vm.$emit('attach', json.result.physical_exam)

            }
        },
        watch: {
            exam(val){
                this.setDefaults()
            }
        }
    }
</script>